import { Link } from 'react-router-dom';
import { MessageCircle, Phone, Users, Briefcase, CheckSquare } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useMobileHomeStats } from '@/hooks/useMobileHomeStats';

const entries = [
  { label: 'Contatos', to: '/m/contacts', icon: Users },
  { label: 'Mensagens', to: '/m/whatsapp', icon: MessageCircle },
  { label: 'Negocios', to: '/m/deals', icon: Briefcase },
  { label: 'Tarefas', to: '/m/tasks', icon: CheckSquare },
  { label: 'Chamadas', to: '/m/calls', icon: Phone },
];

export default function MobileHome() {
  const { data: stats, isLoading } = useMobileHomeStats();

  return (
    <div className="space-y-3 p-3">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">CRM Mobile</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-3 gap-2 text-center text-xs">
          <div className="rounded-lg border p-2">
            <p className="text-muted-foreground">Negocios</p>
            <p className="text-sm font-semibold">{isLoading ? '...' : stats?.activeDeals ?? 0}</p>
          </div>
          <div className="rounded-lg border p-2">
            <p className="text-muted-foreground">Tarefas</p>
            <p className="text-sm font-semibold">{isLoading ? '...' : stats?.pendingTasks ?? 0}</p>
          </div>
          <div className="rounded-lg border p-2">
            <p className="text-muted-foreground">Nao lidas</p>
            <p className="text-sm font-semibold">{isLoading ? '...' : stats?.unreadMessages ?? 0}</p>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-2 gap-2">
        {entries.map((item) => (
          <Link key={item.to} to={item.to} className="rounded-lg border bg-card p-3">
            <item.icon className="mb-2 h-5 w-5 text-primary" />
            <p className="text-sm font-medium">{item.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
